export default __webpack_public_path__ + "static/ai-marketing-7--mobile-6056f687a8eb4b7ae6bba19650a20e03.webp";